import { root } from '../../../../../store/constants';

export const isInsertPerformance = (
) => {
    return root.App.model.get('insertPerformance') === true;
}
